/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface EmployeeDirect {
  /**
   * The unique id of the employees direct.
   */
  id: string;
  /**
   * The gid of the employees direct.
   */
  gid?: string | null;
  /**
   * The first name of the employees direct.
   */
  firstname?: string | null;
  /**
   * The last name of the employees direct.
   */
  lastname?: string | null;
  /**
   * The primary assigned org code of the employees direct.
   */
  paOrgCode?: string | null;
  /**
   * MercerStanding validation state -- if any
   */
  mercerStandingValidationState?: EmployeeDirectMercerStandingValidationStateEnum | null;
  /**
   * True when the employee security settings mark the position evaluation as read only for the requester\'s role. The state stays visible, but the edit entry point of the row must be locked.
   */
  isCpeReadonly?: boolean;
}
export enum EmployeeDirectMercerStandingValidationStateEnum {
  Open = 'Open',
  RequestedHr = 'RequestedHR',
  RequestedCb = 'RequestedCB',
  Approved = 'Approved',
  Rejected = 'Rejected'
}
